import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Livecoding recap: Blockchain-redux now shares blocks between clients in real-time",
  "description": "",
  "published": "2018-04-10T00:00:00.000Z",
  "redirect_from": ["/blog/blockchain-redux-shares-blocks-between-clients-real-time/swizec/8320"],
  "categories": "blockchain, Front End, Livecoding, react, redux",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <lite-youtube {...{
      "videoid": "N9YIInvZZEU",
      "videostartat": "0"
    }}></lite-youtube>
    <p>{`Sunday was fun. We built a thing! 🎉`}</p>
    <p>{`Well… we added a thing to the You Can Use Blockchain To Store And Share UI State proof of concept I've been livecoding on. I'd share a live link with you, but… err… the app broke.`}</p>
    <p><em parentName="p">{`This is a Livecoding Recap – an almost-weekly post about interesting things discovered while livecoding. Usually shorter than 500 words. Often with pictures. Livecoding happens almost `}<strong parentName="em">{`every Sunday at 2pm PDT`}</strong>{` on multiple channels. You should subscribe to `}<a parentName="em" {...{
          "href": "https://www.youtube.com/TheSwizec"
        }}>{`My Youtube`}</a>{` channel to catch me live.`}</em></p>
    <p>{`It was working, you see. Then it wasn't. Infinite loop on page load.`}</p>
    <p><img parentName="p" {...{
        "src": "/23e2e5b6114f056d759dae63e6b90a70/media-6lScd4x2D5Oko-giphy.gif",
        "alt": null
      }}></img></p>
    <p>{`Next time! I promise.`}</p>
    <p>{`We did get `}<em parentName="p">{`something`}</em>{` working, however. When you `}<inlineCode parentName="p">{`dispatch`}</inlineCode>{` an action on `}<inlineCode parentName="p">{`blockchain-redux`}</inlineCode>{`, the generated block is shared live with all other clients. That sharing still happens via Firebase, so it's not thaaaat impressive, but it's a step in the right direction.`}</p>
    <blockquote {...{
      "className": "twitter-tweet",
      "data-dnt": "true"
    }}><p parentName="blockquote" {...{
        "lang": "en",
        "dir": "ltr"
      }}>{`YAY IT WORKS!!!!!1111oneone blockchain-redux is getting useful for realz`}<br parentName="p"></br><br parentName="p"></br>{`Blocks are shared between clients in real-time. Still backed by Firebase, but baby steps.`}<br parentName="p"></br><br parentName="p"></br>{`🤘 `}<a parentName="p" {...{
          "href": "https://t.co/3L6uO3YenT"
        }}>{`pic.twitter.com/3L6uO3YenT`}</a></p>{`— Swizec Teller published ServerlessHandbook.dev (@Swizec) `}<a parentName="blockquote" {...{
        "href": "https://twitter.com/Swizec/status/983112275526496256"
      }}>{`April 8, 2018`}</a></blockquote>
    <p>{`See, you create new benchmark measurements in one browser window, and the other window reacts. Magic 🧙‍♂️`}</p>
    <p>{`Here's how it works 👇`}</p>
    <h2 {...{
      "id": "how-blockchain-redux-shares-blocks-between-clients-in-real-timeat"
    }}>{`How blockchain-redux shares blocks between clients in real timeat`}</h2>
    <p>{`Long validation times got you down? Blockchain-redux is all real-time with the `}<inlineCode parentName="p">{`firebaseMiddleware`}</inlineCode>{`. Soon with the WebRTC middleware too, I hope.`}</p>
    <p>{`In part that's because there's no `}<em parentName="p">{`real`}</em>{` consensus algorithm. Any valid block is accepted to the chain. Longest chain wins by default.`}</p>
    <p>{`You may have seen `}<a parentName="p" {...{
        "href": "https://swizec.com/blog/blockchain-redux-experiment-part-2/swizec/8055"
      }}>{`how blockchain initialization works`}</a>{` before. We read the whole chain from Firebase and replace the local chain stub.`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2018/04/firebase-blockchain-init.png",
        "alt": "Initializing the blockchain from Firebase"
      }}></img></p>
    <p>{`You can read more `}<a parentName="p" {...{
        "href": "https://swizec.com/blog/blockchain-redux-experiment-part-2/swizec/8055"
      }}>{`details about this code in a previous blogpost`}</a>{`.`}</p>
    <p>{`The part that's new is calling `}<inlineCode parentName="p">{`listenForNextBlock`}</inlineCode>{` after replacing the local chain.`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2018/04/wait-for-next-block.png",
        "alt": "Listen for the next block"
      }}></img></p>
    <p>{`We have a local chain and want to make sure we catch the next block that shows up. So we fetch the latest index with `}<inlineCode parentName="p">{`store.getLastBlock().index`}</inlineCode>{`, increment by 1, and listen for changes on `}<inlineCode parentName="p">{`blockchain/\${nextIndex}`}</inlineCode>{`.`}</p>
    <p>{`When that block shows up, we call `}<inlineCode parentName="p">{`valueHandler`}</inlineCode>{`.`}</p>
    <p><inlineCode parentName="p">{`valueHandler`}</inlineCode>{` then parses the value and calls `}<inlineCode parentName="p">{`store.addBlock()`}</inlineCode>{`, which validates the block fits our chain, and if it does fit, it gets added. If the block makes it to our local chain, then the redux-y stuff kicks in, wakes up all subscribed components, and re-renders happen.`}</p>
    <h2 {...{
      "id": "completely-transparent-to-your-app"
    }}>{`Completely transparent to your app`}</h2>
    <p>{`All this real-time sharing is completely invisible to your app. You build your code just like it was any other Redux-based app.`}</p>
    <p>{`To initialize the blockchain and render a live count of nodes, you'd do something like this 👇`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`// App.js

class App extends Component {
    blockchain = {};

    componentDidMount = async () => {
        const FirebaseApp = firebase.initializeApp({
            apiKey: "",
            databaseURL: "https://thing.firebaseio.com",
            projectId: "thing"
        });

        this.blockchain = await createStore(
            benchmarkReducer,
            firebaseMiddleware(FirebaseApp)
        );

        this.unsubscribe = this.blockchain.subscribe(() => {
            console.log("Hello");
            this.forceUpdate();
        });
        this.forceUpdate();
    };

    componentWillUnmount() {
        this.unsubscribe();
    }

   render() {
        console.log("in render", this.blockchain);

        if (this.blockchain.getState) {
            console.log("Current state", this.blockchain.getState());
        }

        return (
        <div class="App">
            <blockchaincontext class="provider" value={this.blockchain}>
                <introcopy>

                <blockchaincontext class="consumer">
                    {blockchain => (
                        <benchmarks blockchain={blockchain}>
                    )}
                </benchmarks></blockchaincontext>

                <div style={{ padding: "3vh" }}>

        </div>
         );
    }
}
</introcopy></blockchaincontext></div>
`}</code></pre>
    <p>{`Initialize the store in `}<inlineCode parentName="p">{`componentDidMount`}</inlineCode>{`, subscribe to changes, run `}<inlineCode parentName="p">{`forceUpdate`}</inlineCode>{` to get around async issues, unsubscribe on unmount.`}</p>
    <p>{`The best way to make this store available to the rest of your app is via the new context API using `}<inlineCode parentName="p">{`<Context.Provider value={this.blockchain}>`}</inlineCode>{`.`}</p>
    <p>{`Then inside `}<inlineCode parentName="p">{`<IntroCopy />`}</inlineCode>{`, where you display the node count, you do something like this.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`// IntroCopy.js

// functional component boilerplate ...
// ... render stuff

<blockchaincontext class="consumer">
    {({ getWholeChain = () => [] }) => (
        There are {getWholeChain().length} nodes on the chain
    )}
</blockchaincontext>

// ... more other render stuff
`}</code></pre>
    <p>{`Value passed into render prop is the whole `}<inlineCode parentName="p">{`blockchain`}</inlineCode>{` store. Take out `}<inlineCode parentName="p">{`getWholeChain`}</inlineCode>{` and show the length. You could use `}<inlineCode parentName="p">{`getState()`}</inlineCode>{` to get the latest block value, for example.`}</p>
    <p>{`Lots of stuff you can do.`}</p>
    <p>{`And to add a new block? Just call `}<inlineCode parentName="p">{`dispatch`}</inlineCode>{` and have a reducer. Blockchain-redux handles the rest :)`}</p>
    <h2 {...{
      "id": "next-steps"
    }}>{`Next steps`}</h2>
    <p>{`Still have to resolve a few TODO comments around block conflicts. What happens if your network is slow and you add blocks locally that other clients haven't seen and you get blocks from the outside world that conflict? Which do you pick?`}</p>
    <p>{`I'm not sure yet.`}</p>
    <p>{`Plus I really want to move away from Firebase. That's gonna be fun.`}</p>
    <p>{`Join me next Sunday as we continue exploring this experiment.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      